<script>
import codeTable from '@/components/table';
import edit from './codeEdit';
import topBar from './topbar';
import columnsConfig from '@/modules/config/columns';
import {mapActions, mapMutations, mapGetters} from 'vuex';
export default {
	created() {
		this.handleGetPolicyList();
		this.promiseAll();
	},
	data() {
		return {
			policyOption: {
				data: [],
				pageQuery: {
					total: 0,
					pageSize: 20,
					currentPage: 1,
					pageSizeList: [20, 40, 60]
				},
				searchQuery: {
					title: '',
					queryTimeBegin: '',
					queryTimeEnd: '',
					infoTypeId: '',
					authStatus: ''
				}
			},
			codeDetail: {},
			selectOption: {
				authStatus: [],
				infoTypeId: []
			},
			dialogOption: {
				width: '40%',
				title: '项目编辑',
				type: 1, // 0新增， 1编辑
				show: false
			}
		}
	},
	methods: {
		// 获取选择项
        promiseAll() {
            Promise.all([this.getStateList(), this.getPolicyInfoTypeList()]).then(res => {
                this.selectOption.authStatus = res[0].data || [];
                this.selectOption.infoTypeId = res[1].data || [];
            });
        },
		handleDelete(row){
            this.$confirm('此操作将永久删除, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.delete(row);
            })
		},
        async delete(row){
			const id = row.id;
			const {code} = await this.policyDel({id});
			if (Object.is(code, 200)) {
				this.$message.success('删除成功');
				this.handleGetPolicyList();
			}
		},
		handleEdit(row, type, title) {
			this.codeDetail = row;
			this.dialogOption.type = type;
			this.dialogOption.title = title;
			this.dialogOption.show = true;
			this.$nextTick(()=> {
				this.$refs.edit.modelStatus(true);
			});
		},
		async handleGetPolicyList() {
			this.$loading(true);
			const {searchQuery, pageQuery} = this.policyOption;
			const {pageSize, currentPage} = pageQuery;
			try {
				const {code, data} = await this.getPolicyList({
					...searchQuery, pageSize, currentPage
				});
				this.policyOption.data = data && data.dataSource || [];
				this.policyOption.pageQuery.total = data.total;
			} catch (e) {
				throw e;
			} finally {
			    this.$loading(false);
			}
		},
		skipPage({id}) {
			this.$router.push({
				path: `/audit/guide/detail/${id}`,
				query: {
					event: 'getPolicyDetail'
				}
			})
		},
		change() {
			this.policyOption.pageQuery.currentPage = 1;
		},
		...mapActions('zft',['getPolicyList', 'policyDel', 'policyUpdate','getStateList', 'getPolicyInfoTypeList'])
	},
	computed: {
		columns() {
			return columnsConfig;
		}
	},
	components: {
		codeTable, topBar, edit
	}
}
</script>
<template>
<div class="rule-list">
	<top-bar :handlerCodeSearch="handleGetPolicyList"
	  :searchQuery="policyOption.searchQuery"
	  :selectOption="selectOption"
	  @change="change"
	></top-bar>
    <code-table
     :data="policyOption.data"
     :columns="columns.policyColumns"
     :searchEvent="handleGetPolicyList"
     :pageOptions="policyOption.pageQuery"
    >
	    <el-table-column label="项目标题" align="center" slot="title" width="150" :show-overflow-tooltip="true">
            <template slot-scope="scope">
				<span class="active" @click="skipPage(scope.row)">{{scope.row.title}}</span>
	        </template>
        </el-table-column>
        <el-table-column label="操作" align="left" width="150" slot="operate" fixed="right">
            <template slot-scope="scope">
				<el-button type="success" :disabled="+scope.row.authStatus === 1"  @click="handleEdit(scope.row, 2, '审核')">审核</el-button>
	            <!-- <el-button type="success"  @click="handleEdit(scope.row, 1, '项目编辑')">编辑</el-button> -->
	        	 <el-button type="success"  @click="handleDelete(scope.row)">删除</el-button>
	        </template>
        </el-table-column>
    </code-table>
    <edit ref="edit"
	  :codeEvent="policyUpdate"
	  :searchEvent="handleGetPolicyList"
	  :codeDetail="codeDetail"
	  :dialogOption="dialogOption"
	  :selectOption="selectOption"
	></edit>
</div>
</template>
<style scoped lang="stylus">
.rule-list
    padding 20px 20px 0
	.active
	    color #286AB1
</style>
